<button
    class="item sir-text-style-paragraph-m-default"
    [class.compact]="compact()"
    [class.compact-icon]="compactIcon()"
    [class.selected-option]="isSelected()"
    (click)="onClick()"
    data-cy="user-option">
    @if (option().icon) {
        <sirius-icon class="icon" [name]="option().icon!"></sirius-icon>
    }
    @if (title() && !description()) {
        <span class="option-text" data-cy="option-title">
            {{ title() }}
        </span>
    } @else {
        <div>
            <span class="option-title sir-text-style-paragraph-m-bold" data-cy="option-title">{{ title() }}</span>
            <p class="option-text" data-cy="option-description">{{ description() }}</p>
        </div>
    }
</button>
